






import Vue from 'vue'
import {NOTIFICA_SUCCESSO, NOTIFICA_ERRORE} from '../../../costanti'

export default Vue.extend({
    props: ['notification'],
    computed: {
        classObject() {
            switch (this.notification.name) {
                case NOTIFICA_SUCCESSO:
                    return 'toast-success'
                case NOTIFICA_ERRORE:
                    return 'toast-error'
                default:
                    return 'toast-primary'
            }
        }
    }
})
